import React, { Fragment } from 'react'
import LogoDropDown from './LogoDropDown'
import PropTypes from 'prop-types'
import Constants from 'scripts/base/Constants'
import {Link} from 'react-router-dom'

const LogoItem = (props) => {
  const lang = props.locale ? props.locale.getLanguage() : Constants.DefaultLang
  return (
    <Fragment>
      {/* <a href="javascript:;" onClick={this.props.toggleWithId}> */}
      <Link to={`/${lang !== Constants.DefaultLang ? lang : ''}`}>
        <span className="logo"></span>
        {/* <i className="icon-arrow-down navbar-subnav-indicator"></i> */}
      </Link>
      <LogoDropDown {...props} id='soompi' />
    </Fragment>
  )
}

LogoItem.propTypes = {
  id: PropTypes.string,
  toggleWithId: PropTypes.func,
  dropdown: PropTypes.string
}

export default LogoItem



// WEBPACK FOOTER //
// ./assets/js/components/navigations/logo/LogoItem.jsx